export enum IRRIGATION_STATE {
    OPEN,
    CLOSED,
    OPENING,
    CLOSING,
    SCHEDULED_IRRIGATION,
}
